export default __webpack_public_path__ + "static/media/account.d81cf50c.svg";